import { Component } from "@theme/component";

class NavigationPanel extends Component {
  requiredRefs = ['mainMenu', 'subMenus', 'footerMenu'];

  showSubMenu(event) {
    const { mainMenu, subMenus, footerMenu } = this.refs;

    if (!mainMenu || !subMenus || !footerMenu) return;

    const { subMenuIndex } = event.target.dataset;

    mainMenu.classList.add('navigation-panel__main-menu--hidden');
    this.querySelectorAll('.navigation-panel__sub-menu').forEach((subMenu) => {
      subMenu.classList.toggle('hidden', subMenu.dataset.index != subMenuIndex);
    });

    setTimeout(() => {
      subMenus.classList.remove('navigation-panel__sub-menus--hidden');
    }, 310);
    footerMenu.classList.add('navigation-panel__secondary-menu--hidden');
  }

  showMainMenu() {
    const { mainMenu, subMenus, footerMenu } = this.refs;

    if (!mainMenu || !subMenus || !footerMenu) return;

    subMenus.classList.add('navigation-panel__sub-menus--hidden');
    setTimeout(() => {
      mainMenu.classList.remove('navigation-panel__main-menu--hidden');
    }, 310);
    footerMenu.classList.remove('navigation-panel__secondary-menu--hidden');
  }

  closeOtherAccordions(event) {
    this.refs.accordions?.forEach((accordion) => {
      if (accordion.isSameNode(event.target)) {
        return;
      }

      accordion.open = false;
    })

  }
}

if (!customElements.get('navigation-panel')) {
  customElements.define('navigation-panel', NavigationPanel);
}